import React from 'react'

function ReadInstrucUploadDoc(props) {


 const {value} = props
  return (
    <div>
      <p>{value}</p>
    </div>
  )
}

export default ReadInstrucUploadDoc
